import { useEffect, useState } from "react";
import "./index.css";
import Navbar from "./Navbar";
import Home from "./Home";
import Work from "./Work";

function App() {
  const getHashPath = () => {
    const rawHash = window.location.hash.replace(/^#/, "");
    const normalized = rawHash === "" || rawHash === "/" ? "/" : rawHash;
    return normalized.startsWith("/") ? normalized : `/${normalized}`;
  };

  const [path, setPath] = useState(getHashPath());

  useEffect(() => {
    if (!("IntersectionObserver" in window)) {
      document.querySelectorAll("[data-reveal]").forEach((element) => {
        element.classList.add("is-visible");
      });
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("is-visible");
        });
      },
      { threshold: 0.14 },
    );

    const elements = document.querySelectorAll("[data-reveal]");
    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, [path]);

  useEffect(() => {
    const onHashChange = () => setPath(getHashPath());
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  return (
    <div className="site-shell">
      <Navbar />
      {path.startsWith("/work") ? <Work path={path} /> : <Home />}
    </div>
  );
}

export default App;
